import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { LoadingSpinner, Stack } from '@adc/parallax-component-library';
import { useApiError, useConnection } from 'Hooks';
import { LogoActionBar, Main, ScrollContainer } from 'Components/utility';
// import { notifyApp } from 'Utilities/appCommunicator';
// import i18n from 'Utilities/i18n';
import LLUCardConnection from './LLUCardConnection';
// import LibreViewCardConnection from './LibreViewCardConnection';
// import PartnerConnectionCard from './PartnerConnectionCard';
const mapStateToProps = ({ env: { app } }) => {
    return {
        isLibre: app === 'libre1',
    };
};
const connector = connect(mapStateToProps);
const MainConnection = ({ isLibre }) => {
    const { getConnections } = useConnection();
    const { showApiErrorModal } = useApiError();
    const [loading, setLoading] = useState(true);
    const [connections, setConnections] = useState();
    useEffect(() => {
        const loadConnections = async () => {
            try {
                setLoading(true);
                const connections = await getConnections();
                setConnections(connections);
            }
            catch {
                showApiErrorModal();
            }
            finally {
                setLoading(false);
            }
        };
        loadConnections();
    }, [getConnections, showApiErrorModal]);
    return (React.createElement(Main, null,
        React.createElement(LogoActionBar, { testID: "Connections" }),
        loading ? (React.createElement(Stack, { width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flex: 1 },
            React.createElement(LoadingSpinner, { testID: "LibreLinkUp.spinner" }))) : (React.createElement(ScrollContainer, { marginTop: 115 },
            React.createElement(Stack, { padding: "$4" },
                React.createElement(LLUCardConnection, { caregiverInvitations: connections?.caregiverInvitations, caregiverConnections: connections?.caregiverConnections, isLibre: isLibre }))))));
};
export default connector(MainConnection);
